import { PermissionsMapEnum } from '@/_types/permissions';
import { PERMISSIONS_DATA } from '@/_constants/permissions';
import type { UserPermissions } from '@/_types/models/user';

export const getPermissions = (
  ids: Array<PermissionsMapEnum>,
): Array<string> => {
  if (!ids?.length) return [];

  return ids.map((id) => PERMISSIONS_DATA[id]?.name).filter(Boolean);
};

export const getHasPermission = (
  permissionKey: PermissionsMapEnum,
  permissions: Array<UserPermissions>,
  company_id?: unknown,
): boolean => {
  if (!permissionKey) return false;
  if (!permissions?.length) return false;

  const getFilteredCompanyId = (id: unknown): number | null => {
    if (typeof id === 'number') return id;
    if (typeof id === 'string' && id !== '') {
      const parsed = parseInt(id, 10);

      return !isNaN(parsed) ? parsed : null;
    }

    return null;
  };

  const filteredCompanyId = getFilteredCompanyId(company_id);

  return !!permissions?.find((p) => {
    if (p.id !== permissionKey) return false;

    // If permission has no company_ids or empty array, treat as global
    if (!p.company_ids || p.company_ids.length === 0) {
      return true;
    }

    // If we have a valid company_id and permission has company restrictions, check if included
    if (filteredCompanyId !== null) {
      return p.company_ids.includes(filteredCompanyId);
    }

    // No valid company_id provided but permission has restrictions
    return false;
  });
};
